'use client'

import RouteErrorBoundary from '@/components/common/RouteErrorBoundary'

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <RouteErrorBoundary
      error={error}
      reset={reset}
      title="Error loading market page"
      description="Something went wrong while loading the market page. Please try again."
      homeRoute="/"
      route="/variable"
    />
  )
}
